import React from 'react';
import { Radio } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './dictionary';
import './styles.scss';

export default function CustomRadioGroup(props) {
	const country = props.country || Enviroment.LANGUAGE;
	return <Radio.Group {...props} className={Dictionary[country][props.className]} />;
}
